export default __webpack_public_path__ + "static/media/MarketUpdate.e1e5bffb.svg";